<template>
  <div>
    <div class="title">
      地区选择配置
    </div>
    <div class="margin_container">
      <el-checkbox-group v-model="selectVal.optionsValue">
        <el-checkbox
          v-for="item in city_type"
          :key="item.label"
          :label="item.label"
        >
          {{
            item.title
          }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>
<script>
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export default {
  name: 'SpSelectCityConfig',
  mixins: [mixin],
  data () {
    return {
      selectVal: {
        optionsValue: []
      },
      city_type: [
        {
          'title': '省',
          'label': 'Province'
        },
        {
          'title': '市',
          'label': 'City'
        },
        {
          'title': '区',
          'label': 'region'
        }
      ]
    }
  },
  watch: {},
  created () {},
  methods: {}
}
</script>
<style scoped lang="scss">
.title {
  font-size: 16px;
}
.margin_container {
  display: flex;
  margin-top: 15px;
}
</style>
